import React from 'react';
import { useSelector } from 'react-redux';
import BillDetails from '../../Components/BillDetails/BillDetails';
import CartCard from '../../Components/CartCard/CartCard';

const Checkout = () => {
    const { carts, products } = useSelector(state => state);
    let allCarts = [];
    carts.forEach(single => {
        products.forEach(element => {
            if (single.id === element.id) {
                allCarts = [
                    ...allCarts,
                    {
                        ...element,
                        ...single,
                    }
                ]
            }

        });
    })
    const total = allCarts.reduce((pre, current) => {
        const singleProductBill = current.price * current.quantity;
        return singleProductBill + pre
    }, 0)
    return (
        <main className="py-16">
            <div className="container 2xl:px-8 px-2 mx-auto">
                <h2 className="mb-8 text-xl font-bold">Shopping Cart</h2>
                <div className="cartListContainer">
                    <div className="space-y-6">
                        {
                            allCarts.length ? allCarts.map(single => <CartCard key={single.id} {...single}></CartCard>) : <div>
                                Please add product to cart first
                            </div>
                        }
                    </div>

                    {/* <!-- Bill Details --> */}
                    <div>
                        <BillDetails total={total}></BillDetails>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Checkout;